module.exports = __webpack_public_path__ + "media/images/index/feature/top-aoj-c-b57cd01af2cb9ab704dd69baa06ddd09.png";